import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative w-full min-h-[90vh] flex items-center justify-center bg-midnight overflow-hidden pt-12 pb-20 px-6" data-id="element-83">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-84">
        <motion.div className="flex flex-col items-start z-10" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-85">
          <div className="inline-block bg-cyan-signal/10 border border-cyan-signal/30 px-3 py-1 mb-6" data-id="element-86">
            <span className="text-cyan-signal font-bold tracking-[0.2em] text-xs uppercase" data-id="element-87">
              Protocolo de 72 Horas
            </span>
          </div>

          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[0.9] uppercase text-bone mb-6" data-id="element-88">
            <span className="text-cyan-signal block mb-2" data-id="element-89">S.O.S.</span>
            Insomnio
            <br data-id="element-90" />
            Masculino
          </h1>

          <h2 className="text-steel text-lg md:text-xl font-body leading-relaxed mb-10 max-w-lg" data-id="element-91">
            El Protocolo de 72 Horas para Apagar tu Cerebro y Recuperar tu
            Energía de Hombre de Alto Rendimiento
          </h2>

          <div className="w-full sm:w-auto" data-id="element-92">
            <Button href="#comprar" subtext="Acceso inmediato · Pago único de $6.36" data-id="element-93">
              Mándame el Protocolo Ahora
            </Button>
          </div>
        </motion.div>

        <motion.div className="relative z-10 flex justify-center lg:justify-end" initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-94">
          <div className="relative w-full max-w-lg aspect-square" data-id="element-95">
            <div className="absolute inset-0 bg-cyan-signal/20 blur-[100px] rounded-full" data-id="element-96" />
            <img src="https://cdn.magicpatterns.com/uploads/csFt1e6LnfV1hpmHvacF7z/IM1.png" alt="S.O.S. Insomnio Masculino Mockup" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-97" />
          </div>
        </motion.div>
      </div>
    </section>;
}